// Fetches Embed Url and Embed token for PowerBi
import {stableGetRequest} from '../requests/stableGetRequest.js'
import CryptoJS from "crypto-js";
const powerBiAuthInfo = "powerBiAuthInfo"

export default async function handlePowerBiAuth(token) {
    // VARS
    var header = {
        method: "GET",
        headers: {
            Authorization: token,
        },
    };
    var authInfo

    // Check to see if user doesn't already has authentication
    if (localStorage.getItem(powerBiAuthInfo) === null || localStorage.getItem(powerBiAuthInfo) === undefined) {
        authInfo = await stableGetRequest(process.env.REACT_APP_POWERBI_API + 'powerbi-auth', header)
        // Cache AuthInfo
        localStorage.setItem(
            powerBiAuthInfo,
            CryptoJS.AES.encrypt(
                JSON.stringify(authInfo),
                process.env.REACT_APP_PASS
            ).toString()
        );
    }
    // Fetch Auth From Cache 
    else {
        authInfo = JSON.parse(
            CryptoJS.AES.decrypt(
                localStorage.getItem(powerBiAuthInfo),
                process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
        )

        // Fetch New Info If Expired
        if (authInfo['expires_at'] < Date.now()) {
            authInfo = await stableGetRequest(process.env.REACT_APP_POWERBI_API + 'powerbi-auth', header)
        }
    }
    return authInfo
}



// WEBPACK FOOTER //
// ./src/util/powerBi/handlePowerBiAuth.jsx